import { observer } from 'mobx-react-lite';
import cardsSprite from '../../../../assets/images/blackjack/cards-sprite.png';
import overrideCardsSprite from '../../../../assets/images/blackjack/cards-spriteNew.png';
import overrideCardHolder from '../../../../assets/images/blackjack/new-ver/card-deck-cut.png';
import overrideCardBack from '../../../../assets/images/blackjack/new-ver/card-original.png';
import { applicationStore } from '../../../../store/applicationStore';

export const getBetHistoryDetailsUrl = (url) => `${url}/api/v1/Statistics/details`;

const FakeRenderBlackJackImages = observer(() => {
  const { isOverwriteMainCss } = applicationStore;

  if (isOverwriteMainCss) {
    return (
      <>
        <img src={overrideCardsSprite} alt='' style={{ display: 'none' }} />
        <img src={overrideCardHolder} alt='' style={{ display: 'none' }} />
        <img src={overrideCardBack} alt='' style={{ display: 'none' }} />
      </>
    );
  }
  return <img src={cardsSprite} alt='' style={{ display: 'none' }} />;
});

export default FakeRenderBlackJackImages;
